import { toast } from "@/components/ui/use-toast";
import { PendingAction } from "@/hooks/portfolioSettings/types";
import { NavigateFunction } from "react-router-dom";

// Handle tab change
export const handleTabChange = (
  newTab: string,
  currentTab: string,
  formEdited: boolean,
  setPendingAction: (action: PendingAction | null) => void,
  setShowUnsavedChangesDialog: (show: boolean) => void,
  setActiveTab: (tab: string) => void
) => {
  if (formEdited && currentTab === 'general') {
    // If there are unsaved changes, show dialog and set pending action
    setPendingAction({ type: 'tab', value: newTab });
    setShowUnsavedChangesDialog(true);
  } else {
    // If no unsaved changes, just change the tab
    setActiveTab(newTab);
  }
};

// Handle back button
export const handleBack = (
  currentTab: string,
  formEdited: boolean,
  navigate: NavigateFunction,
  setPendingAction: (action: PendingAction | null) => void,
  setShowUnsavedChangesDialog: (show: boolean) => void
) => {
  if (formEdited && currentTab === 'general') {
    // If there are unsaved changes, show dialog
    setPendingAction({ type: 'back' });
    setShowUnsavedChangesDialog(true);
  } else {
    // If no unsaved changes, just navigate back
    navigate('/');
  }
};

// Handle portfolio change
export const handlePortfolioChange = (
  newPortfolioId: string,
  currentTab: string,
  formEdited: boolean,
  navigate: NavigateFunction,
  setPendingAction: (action: PendingAction | null) => void,
  setShowUnsavedChangesDialog: (show: boolean) => void,
  setSelectedPortfolio: (portfolioId: string) => void
) => {
  console.log('Portfolio change requested to:', newPortfolioId);
  
  if (formEdited && currentTab === 'general') {
    // If there are unsaved changes, show dialog
    setPendingAction({ type: 'portfolio', value: newPortfolioId });
    setShowUnsavedChangesDialog(true);
  } else {
    // If no unsaved changes, update state directly
    console.log('Updating portfolio selection to:', newPortfolioId);
    setSelectedPortfolio(newPortfolioId);
    // Navigation will happen through the useEffect in useNavigationState
  }
};

// Handle add payment method
export const handleAddPaymentMethod = (toast: any) => {
  toast({
    title: "Add Payment Method",
    description: "This would open a payment method form in a real application."
  });
};

// Handle add promo code
export const handleAddPromoCode = (toast: any) => {
  toast({
    title: "Add Promo Code",
    description: "This would open a promo code entry form in a real application."
  });
};

// Handle make primary payment method
export const handleMakePrimary = (methodId: string, toast: any) => {
  toast({
    title: "Payment Method Updated",
    description: `Payment method ${methodId} is now your primary payment method.`
  });
};
